import * as Sentry from "@sentry/browser";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import * as resources from "./locale.json";

let language: string | undefined = document.body.dataset.lang;

if (language === undefined) {
  Sentry.captureException("Language code not found in DOM");
  language = "de";
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    keySeparator: false, // we do not use keys in form messages.welcome
    lng: language,
    nsSeparator: false,
    resources,
  });
